import { render, staticRenderFns } from "./RelatedProfileRow.vue?vue&type=template&id=98d41656&"
import script from "./RelatedProfileRow.vue?vue&type=script&lang=js&"
export * from "./RelatedProfileRow.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProfileRow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports